'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class changelogModel extends ngDepModel
{
	files = [];
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	
	getValue(name){
		switch(name){
			case 'time':
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm:ss (Z)');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
	isDelAction(){
		return (this.action == 'del');
	}
	
	isInsAction(){
		return (this.action == 'ins');
	}
	
	isUpdAction(){
		return (this.action == 'upd');
	}
	
	hasFiles(){
		return (typeof(this.files) !== 'undefined', this.files.length > 0);
	}
	
}